import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { listConversations } from '../api/messagesService';

const Messages: React.FC = () => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['messages-conversations'],
    queryFn: listConversations,
  });

  const items = data?.data || [];

  return (
    <Layout>
      <div className="px-4 sm:px-0 max-w-3xl">
        <h1 className="text-2xl font-bold text-gray-900">Messages</h1>
        <p className="mt-1 text-sm text-gray-600">Your conversations.</p>

        {isLoading && <p className="mt-6 text-sm text-gray-600">Loading…</p>}
        {isError && (
          <div className="mt-6 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
            Failed to load conversations.{' '}
            <button type="button" className="font-medium underline" onClick={() => refetch()}>
              Retry
            </button>
          </div>
        )}
        {!isLoading && !isError && (
          <ul className="mt-6 divide-y divide-gray-200 rounded-lg border border-gray-200 bg-white shadow">
            {items.length === 0 ? (
              <li className="px-4 py-8 text-center text-sm text-gray-500">No conversations yet.</li>
            ) : (
              items.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/messages/${c.id}`}
                    className="block px-4 py-3 hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center justify-between gap-2">
                      <span className="font-medium text-gray-900">
                        {c.name || (c.members.length ? c.members.map((m) => `${m.firstName} ${m.lastName}`).join(', ') : 'Conversation')}
                      </span>
                      {c.unreadCount > 0 ? (
                        <span className="text-xs font-semibold text-primary-600">{c.unreadCount} new</span>
                      ) : null}
                    </div>
                    {c.lastMessage ? (
                      <p className="text-sm text-gray-600 truncate mt-0.5">{c.lastMessage.content}</p>
                    ) : (
                      <p className="text-sm text-gray-400 mt-0.5">No messages</p>
                    )}
                  </Link>
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </Layout>
  );
};

export default Messages;
